// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__PkjMC","contentContainer":"styles_contentContainer__D5Z6Z"};